import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import pointsReducer from "./store/pointsSlice";
import App from "./App";
import AdminApp from "./admin/AdminApp";

const store = configureStore({
    reducer: {
        points: pointsReducer,
    },
    devTools: true,
});

const root = createRoot(document.getElementById("root"));

// Админка живёт на /admin — вручную вбитый адрес, без ссылки/кнопки в
// публичном интерфейсе. Роутинга в остальном приложении нет, так что это
// единственная развилка по window.location.
const isAdminRoute = window.location.pathname.startsWith("/admin");

root.render(
    <React.StrictMode>
        {isAdminRoute ? (
            <AdminApp />
        ) : (
            <Provider store={store}>
                <App />
            </Provider>
        )}
    </React.StrictMode>
);
